import React from "react";
import Seo from "@/components/Seo";
import SectionHeading from "@/components/SectionHeading";
import { useContent } from "@/context/ContentContext";
import { DEFAULT_PRIVACY, DEFAULT_REFUND, fillEmail } from "@/lib/policies";

export default function Privacy() {
  const { content } = useContent();
  const email = content?.contact?.email;
  const privacy = content?.privacy?.body ? content.privacy : DEFAULT_PRIVACY;
  const refund = content?.refund_policy?.body ? content.refund_policy : DEFAULT_REFUND;
  return (
    <div className="pt-32 pb-24">
      <Seo title="Privacy & Policies | Keys Event Center" description="How Keys Event Center collects, uses and protects your information, plus our cancellation and refund policy." />
      <div className="mx-auto max-w-3xl px-6">
        <SectionHeading eyebrow="The Fine Print" title="Privacy & Policies" />
        <section className="card p-6 sm:p-8" aria-labelledby="privacy-h" data-testid="privacy-policy">
          <h2 id="privacy-h" className="font-display text-2xl font-bold text-[#f6ecd4] mb-4">{privacy.title || DEFAULT_PRIVACY.title}</h2>
          <div className="text-sm text-[#cfd6d6] whitespace-pre-line leading-relaxed">{fillEmail(privacy.body, email)}</div>
        </section>
        <section id="refunds" className="card p-6 sm:p-8 mt-6 scroll-mt-28" aria-labelledby="refund-h" data-testid="refund-policy">
          <h2 id="refund-h" className="font-display text-2xl font-bold text-[#f6ecd4] mb-4">{refund.title || DEFAULT_REFUND.title}</h2>
          <div className="text-sm text-[#cfd6d6] whitespace-pre-line leading-relaxed">{fillEmail(refund.body, email)}</div>
        </section>
      </div>
    </div>
  );
}
